/* BaseCamper V5 — Pathfinder hydration (Phase 2)
 * Enhancement layer over server-rendered V5 surfaces. The server grid is ALWAYS
 * the baseline: on any doubt (fetch error, timeout, unknown filter param,
 * unmapped collection, zero-hit mismatch) this file does nothing and the native
 * grid stands (SEO contract §2; the v6.9 bail lessons carried).
 *
 * Provides: location picker (ZIP/radius/geolocate → bc_loc), Meilisearch-rendered
 * grids on For Sale taxonomy collections + /search, distance on cards,
 * "Nearest first" sort, live result counts, "Near you" shelf personalization on
 * the For Sale landing (crawlers always see the server-rendered default shelf).
 */
(function () {
  'use strict';

  /* ---------- location store (shared shape with legacy pathfinder.js) ---------- */
  var DEFAULT_LOC = { lat: 40.755, lng: -111.881, zip: '84111', label: 'Salt Lake City, UT', source: 'default' };
  var RADII = [[0, 'Everywhere'], [25, '25 miles'], [50, '50 miles'], [100, '100 miles'], [200, '200 miles'], [500, '500 miles']];
  function readLoc() {
    try { var l = JSON.parse(localStorage.getItem('bc_loc') || 'null'); if (l && l.lat) return l; } catch (e) {}
    return DEFAULT_LOC;
  }
  function saveLoc(l) { try { localStorage.setItem('bc_loc', JSON.stringify(l)); } catch (e) {} }
  function readRadius() { try { var r = parseInt(localStorage.getItem('bc_radius_v5') || '0', 10); return isNaN(r) ? 0 : r; } catch (e) { return 0; } }
  function saveRadius(r) { try { localStorage.setItem('bc_radius_v5', String(r)); } catch (e) {} }

  var loc = readLoc();
  var radius = readRadius();

  /* label sync everywhere */
  function syncLabels() {
    document.querySelectorAll('[data-bc-loc-label]').forEach(function (el) {
      el.textContent = loc.label || (loc.zip ? 'ZIP ' + loc.zip : 'Set location');
    });
  }
  syncLabels();

  /* ---------- location picker popover ---------- */
  var boot = document.querySelector('[data-bc-v5-engine]');
  var ZIPS_URL = boot && boot.dataset.zipsUrl;
  var CITIES_URL = boot && boot.dataset.citiesUrl;
  var HOST = boot && boot.dataset.msHost;
  var KEY = boot && boot.dataset.msKey;
  var MODE = boot && boot.dataset.mode;
  var zipCache = null, cityCache = null;
  function loadJson(url, cacheName, cb) {
    if (!url) return cb(null);
    if (cacheName === 'zip' && zipCache) return cb(zipCache);
    if (cacheName === 'city' && cityCache) return cb(cityCache);
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      if (cacheName === 'zip') zipCache = j; else cityCache = j;
      cb(j);
    }).catch(function () { cb(null); });
  }

  var picker = null;
  function buildPicker() {
    if (picker) return picker;
    picker = document.createElement('div');
    picker.className = 'bc-locpop';
    picker.hidden = true;
    var opts = RADII.map(function (r) {
      return '<option value="' + r[0] + '"' + (r[0] === radius ? ' selected' : '') + '>' + r[1] + '</option>';
    }).join('');
    picker.innerHTML =
      '<div class="bc-locpop__head">Search location' +
      '<button type="button" class="bc-locpop__x" data-bc-loc-close aria-label="Close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div>' +
      '<div class="bc-locpop__row"><input type="text" class="bc-input" inputmode="numeric" maxlength="5" placeholder="5-digit ZIP" value="' + (loc.zip || '') + '" data-bc-zip aria-label="ZIP code">' +
      '<select class="bc-input" data-bc-radius aria-label="Search radius">' + opts + '</select></div>' +
      '<button type="button" class="bc-locpop__geo" data-bc-geo>' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="2" x2="5" y1="12" y2="12"/><line x1="19" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="5"/><line x1="12" x2="12" y1="19" y2="22"/><circle cx="12" cy="12" r="7"/></svg>' +
      ' Use my location</button>' +
      '<div class="bc-locpop__msg" data-bc-msg aria-live="polite"></div>' +
      '<div class="bc-locpop__foot"><button type="button" class="btn btn--primary" data-bc-loc-apply>Apply</button></div>';
    document.body.appendChild(picker);

    var msg = picker.querySelector('[data-bc-msg]');
    picker.querySelector('[data-bc-geo]').addEventListener('click', function () {
      if (!navigator.geolocation) { msg.textContent = 'Not supported — enter a ZIP'; return; }
      msg.textContent = 'Locating…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        loc = { lat: Math.round(pos.coords.latitude * 1000) / 1000, lng: Math.round(pos.coords.longitude * 1000) / 1000, zip: '', label: 'Near you', source: 'geo' };
        msg.textContent = 'Got it — near you';
        nearestLabel(loc.lat, loc.lng);
      }, function () { msg.textContent = 'Blocked — enter a ZIP'; }, { timeout: 8000, maximumAge: 600000 });
    });
    picker.querySelector('[data-bc-loc-apply]').addEventListener('click', function () {
      var zipEl = picker.querySelector('[data-bc-zip]');
      var zip = (zipEl.value || '').trim();
      var r = parseInt(picker.querySelector('[data-bc-radius]').value, 10) || 0;
      radius = r; saveRadius(r);
      if (zip && zip !== loc.zip) {
        if (!/^\d{5}$/.test(zip)) { msg.textContent = '5-digit ZIP'; return; }
        loadJson(ZIPS_URL, 'zip', function (zt) {
          var hit = zt && zt[zip];
          if (!hit) { msg.textContent = 'ZIP not found'; return; }
          loc = { lat: hit[0], lng: hit[1], zip: zip, label: '', source: 'zip' };
          loadJson(CITIES_URL, 'city', function (ct) {
            if (ct && ct[zip]) loc.label = String(ct[zip]).replace(',', ', ');
            saveLoc(loc); syncLabels(); location.reload();
          });
        });
      } else {
        saveLoc(loc); syncLabels(); location.reload();
      }
    });
    picker.querySelector('[data-bc-loc-close]').addEventListener('click', function () { picker.hidden = true; });
    document.addEventListener('click', function (e) {
      if (picker.hidden) return;
      if (!e.target.closest('.bc-locpop') && !e.target.closest('[data-bc-loc]') && !e.target.closest('.bc-chip--loc')) picker.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') picker.hidden = true; });
    /* mobile: fixed + anchored — stay glued to the chip through any scroll;
       close if the chip scrolls out of view (JP) */
    window.addEventListener('scroll', function () {
      if (picker.hidden || !picker._anchor) return;
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      var r = picker._anchor.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight || r.right < 0 || r.left > window.innerWidth) { picker.hidden = true; return; }
      var w = Math.min(300, window.innerWidth - 24);
      picker.style.top = (r.bottom + 6) + 'px';
      picker.style.left = Math.min(Math.max(12, r.left), window.innerWidth - w - 12) + 'px';
    }, { capture: true, passive: true });
    return picker;
  }
  function nearestLabel(lat, lng) {
    loadJson(ZIPS_URL, 'zip', function (zt) {
      if (!zt) return;
      var best = null, bd = 1e12;
      for (var z in zt) { var d = (zt[z][0] - lat) * (zt[z][0] - lat) + (zt[z][1] - lng) * (zt[z][1] - lng); if (d < bd) { bd = d; best = z; } }
      if (!best) return;
      loadJson(CITIES_URL, 'city', function (ct) {
        if (ct && ct[best] && loc.source === 'geo') { loc.label = String(ct[best]).replace(',', ', '); loc.zip = best; saveLoc(loc); syncLabels(); }
      });
    });
  }
  function openPicker(anchor) {
    var p = buildPicker();
    /* re-tapping the chip toggles closed (JP) */
    if (!p.hidden) { p.hidden = true; return; }
    /* one panel at a time: close any open facet popovers */
    document.querySelectorAll('[data-bc-pop]').forEach(function (x) { x.hidden = true; });
    document.querySelectorAll('[data-bc-pop-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    p._anchor = anchor;
    var r = anchor.getBoundingClientRect();
    if (window.matchMedia('(max-width: 767px)').matches) {
      /* mobile: fixed + anchored under the chip, clamped inside the viewport */
      var w = Math.min(300, window.innerWidth - 24);
      p.style.top = (r.bottom + 6) + 'px';
      p.style.left = Math.min(Math.max(12, r.left), window.innerWidth - w - 12) + 'px';
    } else {
      p.style.top = (window.scrollY + r.bottom + 6) + 'px';
      var left = window.scrollX + r.left;
      if (left + 300 > window.innerWidth) left = Math.max(8, window.innerWidth - 310);
      p.style.left = left + 'px';
    }
    p.hidden = false;
    /* no autofocus on touch: focusing a field pops the keyboard and (on iOS with
       small fonts) zooms the page — the original "squirm" */
    if (!window.matchMedia('(pointer: coarse)').matches) p.querySelector('[data-bc-zip]').focus();
  }
  document.querySelectorAll('[data-bc-loc], .bc-chip--loc').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openPicker(a); });
  });

  /* ---------- shared render helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { n = Number(n || 0); var opts = Number.isInteger(n) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 }; return '$' + n.toLocaleString('en-US', opts); }
  function distRaw(g) {
    if (!g || g.lat == null) return null;
    var R = 3959, dLa = (g.lat - loc.lat) * Math.PI / 180, dLo = (g.lng - loc.lng) * Math.PI / 180;
    var a = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(loc.lat * Math.PI / 180) * Math.cos(g.lat * Math.PI / 180) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }
  function dist(g) {
    var m = distRaw(g);
    if (m == null) return null;
    return m < 10 ? Math.round(m) : Math.round(m / 10) * 10;
  }
  var PIN = '<span class="bc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg></span>';
  var HEART = '<span class="bc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg></span>';
  var TRUCK = '<span class="bc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg></span>';

  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function cardListing(hit) {
    /* no distance on cards (JP, global): City, ST only — distance lives on the PDP */
    var locBits = '';
    if (hit.location_city) locBits = PIN + esc(hit.location_city) + (hit.location_state ? ', ' + esc(hit.location_state) : '');
    else if (hit.shippable) locBits = TRUCK + 'Ships to you';
    return '<article class="bc-card">' +
      '<a href="' + esc(hit.url || ('/products/' + hit.handle)) + '" class="bc-card__media" aria-hidden="true" tabindex="-1">' +
      (hit.image ? '<img src="' + esc(imgUrl(hit.image, 480)) + '" alt="' + esc(hit.title) + '" loading="lazy" width="480" height="360">' : '') +
      (hit.shippable ? '<span class="bc-card__ships">' + TRUCK + 'Ships</span>' : '') + '</a>' +
      '<button type="button" class="bc-card__heart" data-bc-save data-product-id="' + esc(hit.id) + '" data-product-handle="' + esc(hit.handle) + '" aria-label="Save">' + HEART + '</button>' +
      '<div class="bc-card__body"><div class="bc-card__brand"></div>' +
      '<h3 class="bc-card__title"><a href="' + esc(hit.url || ('/products/' + hit.handle)) + '">' + esc(hit.title) + '</a></h3>' +
      '<div class="bc-card__loc">' + locBits + '</div>' +
      '<div class="bc-card__pricerow"><span class="bc-card__price">' + money(hit.price) + '</span>' +
      (hit.condition ? '<span class="bc-badge bc-badge--used">' + esc(hit.condition) + '</span>' : '') + '</div></div></article>';
  }
  function cardRental(hit) {
    var bits = '';
    if (hit.location_city) bits += '<span class="bc-card__locbit">' + PIN + esc(hit.location_city) + (hit.location_state ? ', ' + esc(hit.location_state) : '') + '</span>';
    if (hit.sleeps) bits += '<span class="bc-card__locbit">Sleeps ' + esc(hit.sleeps) + '</span>';
    return '<article class="bc-card bc-card--rental">' +
      '<a href="' + esc(hit.url || ('/products/' + hit.handle)) + '" class="bc-card__media" aria-hidden="true" tabindex="-1">' +
      (hit.image ? '<img src="' + esc(imgUrl(hit.image, 480)) + '" alt="' + esc(hit.title) + '" loading="lazy" width="480" height="360">' : '') +
      '<span class="bc-card__flag"><span class="bc-badge bc-badge--rent">For Rent</span></span></a>' +
      '<button type="button" class="bc-card__heart" data-bc-save data-product-id="' + esc(hit.id) + '" data-product-handle="' + esc(hit.handle) + '" aria-label="Save">' + HEART + '</button>' +
      '<div class="bc-card__body"><h3 class="bc-card__title bc-card__title--rental"><a href="' + esc(hit.url || ('/products/' + hit.handle)) + '">' + esc(hit.title) + '</a></h3>' +
      '<div class="bc-card__loc">' + bits + '</div>' +
      '<div class="bc-card__pricerow"><span class="bc-card__price">' + money(hit.price_per_day || hit.price) + '</span><span class="bc-card__per">/ day</span>' +
      (hit.avg_rating > 0 && hit.reviews_num > 0 ? '<span class="bc-card__rating">★ ' + (Math.round(hit.avg_rating * 10) / 10) + '</span>' : '') + '</div></div></article>';
  }

  /* ---------- "Near you" shelf personalization (For Sale landing) ----------
   * Client-side only: the server-rendered "Near Salt Lake City" default is what
   * crawlers and first-time visitors see. When the visitor has PICKED a location
   * (loc.source !== 'default'), re-title the shelf and re-render it from a
   * geo-sorted engine query. Local gear first; if nothing is local, fill with
   * the nearest shippable items and say so. Any failure → default shelf stands. */
  (function nearShelf() {
    var shelf = document.querySelector('[data-bc-near-shelf]');
    if (!shelf || !HOST || !KEY) return;
    if (loc.source === 'default') return;
    var gridEl = shelf.querySelector('[data-bc-shelf-grid]');
    if (!gridEl) return;
    var h2 = shelf.querySelector('[data-bc-shelf-h2]');
    var sub = shelf.querySelector('[data-bc-shelf-sub]');
    var viewall = shelf.querySelector('[data-bc-shelf-viewall]');
    var NEAR_MI = radius > 0 ? radius : 100; /* the "local" window: picked radius, or 100 mi when set to Everywhere */
    var geoSort = ['_geoPoint(' + loc.lat + ', ' + loc.lng + '):asc'];
    var ctl = new AbortController();
    var timer = setTimeout(function () { ctl.abort(); }, 3000);
    fetch(HOST + '/multi-search', {
      method: 'POST', signal: ctl.signal,
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + KEY },
      body: JSON.stringify({ queries: [
        { indexUid: 'listings', q: '', limit: 8, filter: '_geoRadius(' + loc.lat + ', ' + loc.lng + ', ' + Math.round(NEAR_MI * 1609) + ')', sort: geoSort },
        { indexUid: 'listings', q: '', limit: 8, filter: 'shippable = true', sort: geoSort }
      ] })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        clearTimeout(timer);
        var local = (data.results && data.results[0] && data.results[0].hits) || [];
        var ships = (data.results && data.results[1] && data.results[1].hits) || [];
        var seen = {}, cards = [];
        local.forEach(function (h) { if (cards.length < 4 && !seen[h.handle]) { seen[h.handle] = 1; cards.push(h); } });
        ships.forEach(function (h) { if (cards.length < 4 && !seen[h.handle]) { seen[h.handle] = 1; cards.push(h); } });
        if (!cards.length) return; /* engine empty — server default stands */
        var place = loc.label || (loc.zip ? 'ZIP ' + loc.zip : 'you');
        if (h2) h2.textContent = 'Near ' + place;
        if (sub) sub.textContent = local.length
          ? 'Gear within ' + NEAR_MI + ' miles of ' + place
          : 'Nothing listed near ' + place + ' yet — this gear ships to you';
        if (viewall) viewall.hidden = true; /* its target is the default-location collection */
        gridEl.innerHTML = cards.map(cardListing).join('');
        shelf.setAttribute('data-bc-hydrated', '1');
        if (window.BCFavorites) window.BCFavorites.sync();
      })
      .catch(function () { clearTimeout(timer); /* default shelf stands */ });
  })();

  /* ---------- engine hydration (collection + search grids) ---------- */
  if (!boot) return;
  if (!HOST || !KEY || !MODE) return;
  var PAGE = 24;
  var grid = document.querySelector('[data-bc-results]') || document.querySelector('[data-bc-search-results]');
  var countEl = document.querySelector('.bc-toolbar__count');
  if (!grid) return;

  var params = new URLSearchParams(location.search);
  /* Params this layer understands — anything else means the server result is richer: bail. */
  var ALLOWED = ['q', 'sort_by', 'page', 'preview_theme_id', '_fd', 'pb', 'key', 'view',
    'filter.p.m.custom.condition', 'filter.p.m.custom.price_band', 'filter.p.m.custom.location_state', 'filter.p.product_type'];
  var bail = false;
  params.forEach(function (v, k) { if (ALLOWED.indexOf(k) === -1) bail = true; });
  if (bail) { console.info('[v5-pathfinder] unmapped filter param — native grid stands'); return; }

  var isRentals = (params.get('filter.p.product_type') || '') === 'Rental';
  var handle = boot.dataset.collectionHandle || '';
  var title = boot.dataset.collectionTitle || '';
  if (MODE === 'collection') {
    if (/(^|-)(area)$|just-listed|fresh-finds|featured|frontpage|flash|^near-/.test(handle)) return; /* curated/hub — native */
    if (/rental|drivable|towable/.test(handle)) return; /* rentals collections: native this phase */
  }
  var INDEX = (MODE === 'search' && isRentals) ? 'rentals' : 'listings';

  var filters = [];
  if (MODE === 'collection' && title) {
    filters.push('(category = ' + JSON.stringify(title) + ' OR subcategory = ' + JSON.stringify(title) + ')');
  }
  var cond = params.getAll('filter.p.m.custom.condition');
  if (cond.length) filters.push('(' + cond.map(function (c) { return 'condition = ' + JSON.stringify(c); }).join(' OR ') + ')');
  var bands = params.getAll('filter.p.m.custom.price_band');
  if (bands.length) filters.push('(' + bands.map(function (b) { return 'price_band = ' + JSON.stringify(b); }).join(' OR ') + ')');
  var states = params.getAll('filter.p.m.custom.location_state');
  if (states.length) filters.push('(' + states.map(function (s) { return 'location_state = ' + JSON.stringify(s); }).join(' OR ') + ')');
  if (radius > 0) filters.push('(shippable = true OR _geoRadius(' + loc.lat + ', ' + loc.lng + ', ' + Math.round(radius * 1609) + '))');

  /* default sort: search = Best match (Meilisearch relevance ranking on the query);
     collections have no query to match, so Nearest first is the default there */
  var sortParam = params.get('sort_by') || (MODE === 'search' ? 'relevance' : 'nearest');
  var sort = null;
  if (sortParam === 'nearest') sort = ['_geoPoint(' + loc.lat + ', ' + loc.lng + '):asc'];
  else if (sortParam === 'created-descending') sort = ['created_at_ts:desc'];
  else if (sortParam === 'price-ascending') sort = ['price:asc'];
  else if (sortParam === 'price-descending') sort = ['price:desc'];

  var page = Math.max(1, parseInt(params.get('page') || '1', 10) || 1);
  var q = MODE === 'search' ? (params.get('q') || '') : '';

  var query = { indexUid: INDEX, q: q, limit: PAGE, offset: (page - 1) * PAGE };
  if (filters.length) query.filter = filters.join(' AND ');
  if (sort) query.sort = sort;

  var ctl = new AbortController();
  var timer = setTimeout(function () { ctl.abort(); }, 3000);
  fetch(HOST + '/multi-search', {
    method: 'POST', signal: ctl.signal,
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + KEY },
    body: JSON.stringify({ queries: [query] })
  }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function (data) {
      clearTimeout(timer);
      var res = data.results && data.results[0];
      if (!res || !res.hits) return;
      var total = res.estimatedTotalHits || res.hits.length;
      var nativeHasItems = grid.querySelector('.bc-card');
      if (res.hits.length === 0 && nativeHasItems && filters.length && radius === 0) {
        console.info('[v5-pathfinder] zero-hit mismatch — native grid stands');
        return; /* likely an unmapped taxonomy title */
      }
      render(res.hits, total);
    })
    .catch(function () { clearTimeout(timer); /* native grid stands */ });

  function render(hits, total) {
    grid.innerHTML = hits.map(INDEX === 'rentals' ? cardRental : cardListing).join('') ||
      '<div class="bc-empty">No matches. Try fewer filters or a wider radius.</div>';
    grid.setAttribute('data-bc-hydrated', '1');
    if (countEl) countEl.textContent = total.toLocaleString('en-US') + ' result' + (total === 1 ? '' : 's');
    if (window.BCFavorites) window.BCFavorites.sync();
    /* "No local results" honesty note: with a radius on, shippable items ride along
     * from anywhere — if nothing on this page is actually within the radius, say so
     * instead of letting far-away gear read as a broken location filter. */
    var note = document.querySelector('.bc-localnote');
    if (radius > 0 && hits.length) {
      var localCount = 0;
      hits.forEach(function (h) { var m = distRaw(h._geo); if (m != null && m <= radius) localCount++; });
      if (localCount === 0) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'bc-localnote';
          grid.parentNode.insertBefore(note, grid);
        }
        note.textContent = 'No listings within ' + radius + ' miles of ' + (loc.label || (loc.zip ? 'ZIP ' + loc.zip : 'you')) + ' yet — showing gear that ships to you' + (sortParam === 'nearest' ? ', nearest first' : '') + '.';
      } else if (note) { note.remove(); }
    } else if (note) { note.remove(); }
    /* sort: enable Nearest first */
    var sel = document.getElementById('bc-sort');
    if (sel && !sel.querySelector('option[value="nearest"]')) {
      var o = document.createElement('option');
      o.value = 'nearest'; o.textContent = 'Nearest first';
      sel.insertBefore(o, sel.firstChild);
      if (!params.get('sort_by') && MODE !== 'search') sel.value = 'nearest';
    }
    /* pagination: rebuild from engine total so radius-filtered pages are truthful */
    var pag = document.querySelector('.bc-pagination');
    if (pag) {
      var pages = Math.max(1, Math.ceil(total / PAGE));
      if (pages === 1) { pag.innerHTML = ''; return; }
      function pageUrl(n) { var u = new URL(location.href); u.searchParams.set('page', n); return u.pathname + u.search; }
      var html = '';
      if (page > 1) html += '<a href="' + esc(pageUrl(page - 1)) + '" class="bc-chip">‹ Prev</a>';
      for (var i = 1; i <= pages && i <= 8; i++) {
        html += i === page ? '<span class="bc-page bc-page--on" aria-current="page">' + i + '</span>' : '<a href="' + esc(pageUrl(i)) + '" class="bc-page">' + i + '</a>';
      }
      if (pages > 8) html += '<span class="bc-page bc-page--gap">…</span>';
      if (page < pages) html += '<a href="' + esc(pageUrl(page + 1)) + '" class="bc-chip">Next ›</a>';
      pag.innerHTML = html;
    }
  }
})();
